import { TabsInterfaceNew } from '@prometheus/types';
import i18n from 'i18next';

export const tabs = (): TabsInterfaceNew[] => [
  {
    value: 'databases',
    title: i18n.t('modules.administration.tabs.databases'),
  },
  {
    value: 'vocabulary',
    title: i18n.t('modules.administration.tabs.vocabulary_management'),
  },
  {
    value: 'environments',
    title: i18n.t('modules.administration.tabs.envs'),
  },
  {
    value: 'ee-config',
    title: i18n.t('modules.administration.tabs.proxy'),
  },
  {
    value: 'vaults',
    title: i18n.t('modules.administration.tabs.vaults'),
  },
];
